import Vue from 'vue'

const i18nHelpers = () => Vue.prototype.$i18nHelpers

export const APPOINTMENT = 1
export const SERVICES_PACKAGES = 2
export const FLAT_RATE = 3
export const SUBSCRIPTION_PLUS = 4
export const CHANGE_PAYMENT_METHOD = 5
export const TELECONSULTATION_BONO = 6
export const PENDING_PAYMENT = 7
export const CENTER_APPOINTMENT = 8
export const GIFT_SERVICE = 9
export const APPOINTMENT_ERROR = 10
export const EPRESCRIPTION = 11

export function getPaymentTitleById (paymentType) {
    let messages = require(`@/lang/${i18nHelpers().getNormalizedLocale()}/payments.json`)
    const PAYMENT_TITLES = {
        [SERVICES_PACKAGES]: messages.payments.servicesPackage,
        [FLAT_RATE]: messages.payments.flatRate,
        [TELECONSULTATION_BONO] :messages.payments.teleconsultationBono,
        [PENDING_PAYMENT]: messages.payments.appointmentPendingPayment,
        [APPOINTMENT_ERROR]: messages.payments.errorPayment,
        [SUBSCRIPTION_PLUS]: messages.payments.plusRate
    }
    return PAYMENT_TITLES[paymentType]
}


// WEBPACK FOOTER //
// ./src/constants/paymentTypes.js